import { Link } from 'react-router-dom';
import { ReactComponent as WhatsAppIcono } from '../../../assets/icons/WhatsApp-Icono.svg';

const LicenseUniserseWA = () => {
  return (
    <div className="fixed right-0 bottom-3 z-10  ">
      <div className="flex justify-center xl:justify-end mt-16 md:mt-14 lg:mt-0">
        <div className="flex justify-center items-center flex-row lg:items-center gap-3  ">
          <Link to={'https://linktr.ee/uniserse'} target="_blank">
            <div className="flex flex-col items-center gap-1 bg-white rounded-[20px] px-3 py-2 shadow-xs max-w-[170px] max-lg:max-w-[120px]">
              <span className="fontPSemiBold color-primary text-[11px] max-lg:text-[8.5px] text-center leading-tight">
                Plataforma digital de:
              </span>
              <img
                src="https://aseguramecr.s3.us-east-2.amazonaws.com/logos/logo-mediano-uniserse-3.png"
                alt="Logo Uniserse"
                className="w-auto h-auto max-h-[50px] max-lg:max-h-[30px] object-contain"
              />
              <span className="fontPRegular font-bold color-primary text-[9px] max-lg:text-[7px] bg-[#e5ebef] rounded-full px-3 py-[2px] text-center">
                Licencia: SC-12-115
              </span>
            </div>
          </Link>
          <Link to={'https://wa.me/50686473773'} target="_blank">
            <WhatsAppIcono className="max-w-[98px] max-h-[78px]  cursor-pointer  max-lg:max-w-[58px] max-lg:max-h-[58px]   " />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LicenseUniserseWA;
